import { Injectable } from '@angular/core';
import { IconName } from '../interfaces';
import { HttpClient } from '@angular/common/http';
import { Observable, take } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class IconService {
	constructor(private http: HttpClient) {}

	getIcon(icon: IconName): Observable<string> {
		return this.http.get(`/assets/svg/${icon}.svg`, { responseType: 'text' }).pipe(take(1));
	}
}
